// 校验标注状态
export const hasMarkStateSelector = ({ mark }) => value =>
  (mark.markState & value) === value;
